import type { ClientPropertyLandDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";
import { LAND_CATEGORY_OPTIONS } from "web_myplann/Portfolio/Forms/LandForm/landCategoryOptions";
import { LAND_FORM_DEFAULT_VALUES as DEFAULTS } from "web_myplann/Portfolio/Forms/LandForm/landFormDefaults";
import type { LandFormInput } from "web_myplann/Portfolio/Forms/LandForm/landFormSchema";

const LAND_CATEGORY_VALUES: ReadonlySet<string> = new Set(
	Object.values(LAND_CATEGORY_OPTIONS),
);

export const mapPropertyToLandForm = (
	property: ClientPropertyLandDetailResponseDTO,
): LandFormInput => ({
	name: property.name ?? DEFAULTS.name,
	location: property.location ?? DEFAULTS.location,
	locationMunicipality:
		property.locationMunicipality ?? DEFAULTS.locationMunicipality,
	locationZipCode: property.locationZipCode ?? DEFAULTS.locationZipCode,
	parcelNumber: property.parcelNumber ?? DEFAULTS.parcelNumber,
	propertyCategory:
		property.propertyCategory &&
		LAND_CATEGORY_VALUES.has(property.propertyCategory)
			? (property.propertyCategory as LandFormInput["propertyCategory"])
			: DEFAULTS.propertyCategory,
	landSize: property.landSize ?? DEFAULTS.landSize,
	landValue: property.landValue ?? DEFAULTS.landValue,
	purchaseDate: parseIsoDate(property.purchaseDate),
	description: property.description ?? DEFAULTS.description,
	forInvestments: property.forInvestments ?? DEFAULTS.forInvestments,
});
